import React from 'react';
import PropTypes from 'prop-types';
import ExternalLinkIcon from './icons/ExternalLinkIcon';

const ExternalLink = ({ title, children, href, showIcon, dataTestId }) => {
  return (
    (<a
      data-testid={dataTestId}
      className=""
      title={title}
      href={href}
      target="_blank"
      rel="noopener noreferrer">
      <div data-testid="div-a03404cc" className="flex items-center space-x-1">
        <span data-testid="span-257eacba">{children || title}</span>
        {showIcon ? (
          <ExternalLinkIcon className="w-4 h-4 flex-shrink-0" />
        ) : null}
      </div>
    </a>)
  );
};

ExternalLink.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  showIcon: PropTypes.bool,
};

ExternalLink.defaultProps = {
  showIcon: true,
};

export default ExternalLink;
